import { IonButton, IonCol, IonIcon, IonInput } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import Card from "../Card";
import CardZero from "../CardZero";
import { CellProps } from "./Cell";
import { getPropsWhenConfirmed } from "../../foo/grid";
import { _NEW_LINE, _dict } from "../constants";
import ButtonTemplate from "../templates/ButtonTemplate";
import { checkmark } from "ionicons/icons";

interface CellEditProps {
    index: number;
    updateCell: (index: number, cellProps: Partial<CellProps>) => void;
    initialValue: string;

}

const CellEdit: React.FC<CellEditProps> = ({index, updateCell, initialValue}) => {
    const [inputValue, setInputValue] = useState(initialValue);
    const inputRef = useRef<HTMLIonInputElement>(null);
    
    useEffect(() => {
      const timer = setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.setFocus();
        } 
      }, 500); // Delay in milliseconds
      return () => clearTimeout(timer);
    }, []);
  
    const handleInputChange = (e: CustomEvent) => {
      setInputValue((e.target as HTMLInputElement).value);
    };
  
 
  
    const handleKeyPress = (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        // Push CellEdit to the next cell
        updateCell(index+1, {isEditing: true});
        // Update the current cell
        updateCell(index, getPropsWhenConfirmed(inputValue === "" ? _NEW_LINE : inputValue));

      }
    };

    // Unfortunately onblur callback will prevent click on buttons to work
    const handleBlur = () => {
      updateCell(index, {isEditing: false});
    };
    
    return (<>
        <CardZero
          label={inputValue}
          image={""}
          icons={[]}
          isBorderBlack={true}
          hasInput={true}
          inputRef={inputRef}
          inputInitialValue={inputValue}
          inputHandleInputChange={handleInputChange}
          inputHandleKeyPress={handleKeyPress}
          inputHandleBlur={handleBlur}
        />
        
        </>
              
              
            
    );
    
  };


export default CellEdit;